import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpLoginComponent } from './otp-login/otp-login.component';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
  declarations: [OtpLoginComponent, OtpVerificationComponent, LoginComponent, ForgotPasswordComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class LoginModule { }
